import { passwordRegex } from "@/app/account/constants/regex"

export default function useGetPwdIsValid(pwd?: string) {
  if (pwd === undefined) {
    return true
  }

  if (pwd === "") {
    return false
  } else {
    return passwordRegex.test(pwd)
  }
}
